import * as Field from '@/components/ui/field'
import { Input } from '@/components/ui/input'
import { FieldInformation } from '@components/FieldInformation'
import type { CreateSetup } from '@hvf/contracts'
import type { FormStore } from '@modular-forms/solid'
import { fieldInformation } from '../config/fieldInformation'
import type { FormFieldType } from '../index'

interface CustomTextInputProps {
  name: keyof CreateSetup
  label: string
  type?: 'string' | 'number' // Modular forms types
  form: FormStore<CreateSetup, undefined>
  FormField: FormFieldType
}

export function CustomTextInput(props: CustomTextInputProps) {
  return (
    <props.FormField name={props.name} type={props.type || 'string'}>
      {(field, formFieldProps) => (
        <Field.Root invalid={!!field.error}>
          <FieldInformation information={fieldInformation[props.name]}>
            <Field.Label>{props.label}</Field.Label>
          </FieldInformation>
          <Input
            {...formFieldProps}
            // Map the framework type back to an HTML input type
            type={props.type === 'number' ? 'number' : 'text'}
            // Force TS to ignore the boolean possibility from the generic form store
            value={(field.value as string | number | undefined) ?? ''}
          />
          <Field.ErrorText>
            {field.error && <div>{field.error}</div>}
          </Field.ErrorText>
        </Field.Root>
      )}
    </props.FormField>
  )
}
